// removed by extract-text-webpack-plugin
module.exports = {"pill":"src-components-modules-WelcomeMessage-style----welcome-module---pill---lRTpa display-inlineFlex borderColor-smoke borderStyle-solid borderWidth-1 marginTopBottom-l paddingLeft-m position-relative transitionDuration-m","truncate":"src-components-modules-WelcomeMessage-style----welcome-module---truncate---WfUzA fontSize-m truncateText","bold":"src-components-modules-WelcomeMessage-style----welcome-module---bold---1ywO- fontWeight-5","absolute":"src-components-modules-WelcomeMessage-style----welcome-module---absolute---2uzA9 position-absolute"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/WelcomeMessage/style/welcome.module.css
// module id = 1494
// module chunks = 35783957827783